import React from 'react'
import InBetweenBorderGrid from '../../../../../merge-common/layout/InBetweenBorderGrid'
import ConclusionRowSkeleton from './ConclusionRowSkeleton'

type Props = {
  isResultant?: boolean
}

const VITALS_ROW_COUNT = 3

/** The vitals section while loading. Mirrors VitalsSection with a fixed number of placeholder rows. */
export default function VitalsSectionSkeleton({ isResultant }: Props): JSX.Element {
  return (
    <InBetweenBorderGrid>
      {Array.from({ length: VITALS_ROW_COUNT }, (_, index) => (
        <ConclusionRowSkeleton key={index} isResultant={isResultant} />
      ))}
    </InBetweenBorderGrid>
  )
}
